export const loadingUpdater = (prev) => ({
  ...prev,
  error: false,
  loaded: false,
  loading: true,
})

export const errorUpdater = (prev) => ({
  ...prev,
  error: true,
  loaded: true,
  loading: false,
})

export const pollingIterationUpdater = (prev) => ({
  ...prev,
  pollingIteration: prev.pollingIteration + 1,
})
